import { apiGet, apiSend } from './client';
import type { Environment } from '../constants';
import type { ICatalogueItem, ISubscription, ISubscriptionInput } from '../types';

export const getCatalogue = (environment: Environment): Promise<{ data: ICatalogueItem[] }> =>
  apiGet(environment, '/catalogue');

export const saveCatalogueItem = (
  environment: Environment,
  item: ICatalogueItem,
): Promise<{ data: ICatalogueItem }> =>
  apiSend(environment, `/catalogue/${encodeURIComponent(item.code)}`, 'PUT', item);

export const createSubscription = (
  environment: Environment,
  tenant: string,
  input: ISubscriptionInput,
): Promise<{ data: ISubscription }> =>
  apiSend(environment, `/tenants/${encodeURIComponent(tenant)}/subscriptions`, 'POST', input);

export const endSubscription = (
  environment: Environment,
  tenant: string,
  id: string,
  endsOn: string,
  reason: string | null,
): Promise<{ data: ISubscription }> =>
  apiSend(
    environment,
    `/tenants/${encodeURIComponent(tenant)}/subscriptions/${encodeURIComponent(id)}/end`,
    'POST',
    { ends_on: endsOn, reason },
  );
